<p-sidebar [(visible)]="showPopup"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="handleSideBarHide()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <a style="opacity: 0.5; color: #333333; letter-spacing: -0.43px; font: normal normal bold 18px/12px Montserrat; ">Create Xpress Center</a>
        </div>
    </ng-template>
    <div class="create-center-body">
        <div>
            <div style="font-size: 16px; color: black">Xpress Center Image:</div>
            <img [src]="xpressCenter.ImageUrl" style="max-width:300px;max-height:300px" />
            <div style="margin-bottom: 20px;"><input name="imageUrl" type="file" accept="image/*" (change)="handleInputChange($event)" /></div>
        </div>
        <div class="flex flex-row create-center-fields">
            <a class="create-center-label">Driver Center Name</a>
            <span class="p-float-label">
                <input type="text" pInputText [(ngModel)]="xpressCenter.Name">
            </span>
        </div>
        <div class="flex flex-row create-center-fields">
            <a class="create-center-label">Address:</a>
            <span class="p-float-label">
                <input type="text" pInputText [(ngModel)]="xpressCenter.Address">
            </span>
        </div>
        <div class="flex flex-row create-center-fields">
            <a class="create-center-label">City:</a>
            <span class="p-float-label">
                <input type="text" pInputText [(ngModel)]="xpressCenter.City">
            </span>
        </div>
        <div class="flex flex-row create-center-fields">
            <a class="create-center-label">Contract Start</a>
            <p-calendar [(ngModel)]="xpressCenter.StartedAt"></p-calendar>
        </div>
        <div class="flex flex-row create-center-fields">
            <a class="create-center-label">Contract End</a>
            <p-calendar [(ngModel)]="xpressCenter.EndedAt"></p-calendar>
        </div>
        <div class="flex flex-row create-center-fields">
            <a class="create-center-label">Monthly Rental</a>
            <p-inputNumber [(ngModel)]="xpressCenter.MonthlyRent"
                           mode="currency"
                           currency="PHP"
                           locale="en-US">

            </p-inputNumber>
        </div>
        <div class="flex flex-row create-center-fields">
            <a class="create-center-label">CUSA Fee</a>
            <p-inputNumber [(ngModel)]="xpressCenter.CusaFee"
                           mode="currency"
                           currency="PHP"
                           locale="en-US">

            </p-inputNumber>
        </div>
    </div>
    <div style="display: flex; position: absolute; right: 20px; bottom: 0px; z-index:3">
        <div>
            <button [disabled]="loading" pButton pRipple type="button" (click)="createXpressCenter()"><div style="color: white">Create</div></button>
        </div>
    </div>
</p-sidebar>
<p-toast></p-toast>